import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './App';
import 'focus-visible/dist/focus-visible.min.js';

ReactDOM.render(<App />, document.getElementById('js-login-root'));
